<template>
    <div>
        <label class="title">Workout Intensity</label>
        <div class="row">
            <div class="col">
                <div class="label-name text-muted">Range</div>
                <span class="span-value">{{ workoutStats.minHeartRate }} - {{ workoutStats.maxHeartRate }}</span><span
                    class="text-muted"> bpm</span>
            </div>
            <div class="col">
                <div class="label-name text-muted">Average</div>
                <span class="span-value">{{ workoutStats.avgHeartRate }}</span><span class="text-muted"
                    style="font-size: 0.8rem;"> bpm</span>
            </div>
        </div>
    </div>
    <div class="chart-container">
        <canvas id="workout-intensity-chart"></canvas>
    </div>
    <div class="d-flex justify-content-evenly">
        <div class="status-label rest">
            <div class="color-box"></div>
            <span>Rest</span>
        </div>
        <div class="status-label warm-up">
            <div class="color-box"></div>
            <span>Warm up</span>
        </div>
        <div class="status-label fat-burning">
            <div class="color-box"></div>
            <span>Fat-burning</span>
        </div>
        <div class="status-label aerobic">
            <div class="color-box"></div>
            <span>Aerobic</span>
        </div>
        <div class="status-label anaerobic">
            <div class="color-box"></div>
            <span>Anaerobic</span>
        </div>
        <div class="status-label extreme">
            <div class="color-box"></div>
            <span>Extreme</span>
        </div>
    </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import constants from '@/helpers/constants';

Chart.register(...registerables);
export default {
    name: "WorkoutIntensity",
    mounted() {
        this.renderChart();
    },
    watch: {
        workoutStats() { },
        chartLabels() {
            this.renderChart();
        },
        chartData() {
            this.renderChart();
        }
    },
    props: {
        chartId: {
            type: String,
            default: 'workout-intensity-chart'
        },
        workoutStats: {
            type: Object,
            required: true,
        },
        chartLabels: {
            type: Object,
            required: true,
        },
        chartData: {
            type: Object,
            required: true,
        },
        hrZoneVals: {
            type: Object,
            required: true
        },
    },
    methods: {
        renderChart() {
            let chartStatus = Chart.getChart("workout-intensity-chart");
            if (chartStatus != undefined) {
                chartStatus.destroy();
            }

            const ctx = document.getElementById("workout-intensity-chart").getContext('2d');
            var chartGradient = ctx.createLinearGradient(0, 0, 0, 600);

            let maxGrph = this.workoutStats.maxHeartRate + 5;
            let minGrph = this.workoutStats.minHeartRate - 5;
            let graphPoints = maxGrph - minGrph;
			
            let resting=0, warmup=0,fatBurning=0,aerobic=0,anaerobic=0,extreme=0, division=0;
			if(this.hrZoneVals.restZoneHr > minGrph && 
                    (this.hrZoneVals.warmUpZoneHr >= minGrph && this.hrZoneVals.warmUpZoneHr <= maxGrph)) {
                let gradientPoint = (this.hrZoneVals.warmUpZoneHr-this.hrZoneVals.restZoneHr)/graphPoints;
                warmup = gradientPoint;
                division = division + 1;
            }
			
			if(this.hrZoneVals.warmUpZoneHr > minGrph && this.hrZoneVals.fatBurningZoneHr < maxGrph) {
                let gradientPoint = (this.hrZoneVals.fatBurningZoneHr-this.hrZoneVals.warmUpZoneHr)/graphPoints;
                fatBurning = gradientPoint;
                division = division + 1;
            }
			
			if(this.hrZoneVals.fatBurningZoneHr > minGrph && this.hrZoneVals.aerobicZoneHr < maxGrph) {
               let gradientPoint = (this.hrZoneVals.aerobicZoneHr-this.hrZoneVals.fatBurningZoneHr)/graphPoints;
               aerobic = gradientPoint;
               division = division + 1;
            }
			
			let gapPoints = maxGrph > this.hrZoneVals.aerobicZoneHr ? this.hrZoneVals.anAerobicZoneHr - maxGrph : 0;
            if(this.hrZoneVals.aerobicZoneHr>minGrph && 
                (this.hrZoneVals.anAerobicZoneHr < maxGrph || gapPoints > 0)) {
                let gradientPoint = 0;
                if(this.hrZoneVals.anAerobicZoneHr < maxGrph) {
                    gradientPoint = (this.hrZoneVals.anAerobicZoneHr-this.hrZoneVals.aerobicZoneHr)/graphPoints;
                } else {
                    gradientPoint = gapPoints/graphPoints;
                } 
                anaerobic = gradientPoint;
                division = division + 1;
            }
			
            if(minGrph < this.hrZoneVals.restZoneHr) {
                let gradientPoint = (this.hrZoneVals.restZoneHr-minGrph)/graphPoints;
                resting = gradientPoint;
                division = division + 1;
            }

			if(maxGrph > this.hrZoneVals.anAerobicZoneHr) {
                let gradientPoint = (maxGrph - this.hrZoneVals.anAerobicZoneHr)/graphPoints;
                extreme = gradientPoint;
                division = division + 1;
            }

            let sum = 0;
            if(extreme > 0) {
              sum = sum + extreme;
              let gradientPoint = sum/division;
              chartGradient.addColorStop(gradientPoint, constants.WORKOUT_INTENSITY_COLORS.EXTREME);
            }

            if(anaerobic > 0) {
               sum = sum + anaerobic;
               let gradientPoint = sum/division;
               chartGradient.addColorStop(gradientPoint, constants.WORKOUT_INTENSITY_COLORS.ANAEROBIC);
            }

            if(aerobic > 0) {
               sum = sum + aerobic;
               let gradientPoint = sum/division;
               chartGradient.addColorStop(gradientPoint, constants.WORKOUT_INTENSITY_COLORS.AEROBIC);
            }

            if(fatBurning > 0) {
               sum = sum + fatBurning;
               let gradientPoint = sum/division;
               chartGradient.addColorStop(gradientPoint, constants.WORKOUT_INTENSITY_COLORS.FAT_BURNING);
            }

            if(warmup > 0) {
               sum = sum + warmup;
               let gradientPoint = sum/division;
               chartGradient.addColorStop(gradientPoint, constants.WORKOUT_INTENSITY_COLORS.WARM_UP);
            }

            if(resting > 0) {
               sum = sum + resting;
               let gradientPoint = sum > 1 ? 1 : sum/division;
               chartGradient.addColorStop(gradientPoint, constants.WORKOUT_INTENSITY_COLORS.REST);
            }

            new Chart(ctx, {
                type: 'bar',
                showScale: false, // Hides y Axis title
                data: {
                    labels: this.chartLabels,
                    datasets: [
                        {
                            label: 'Heart Rate Zones',
                            data: this.chartData,
                            borderColor: "#4BB7FF",
                            backgroundColor: chartGradient,
                            hoverBackgroundColor: chartGradient,
                            fill: false,
                            barPercentage: 0.8,
                            borderRadius: 1, //use 10 for bar radius
                            borderSkipped: false,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'bottom',
                            display: false // hides the legends
                        },
                        customCanvasBackgroundColor: {
                            color: '#1C1D1F',
                        },
                        chartArea: {
                            backgroundColor: '#1C1D1F'
                        }
                    },
                    scales: {
                        x: {
                            barPercentage: 1,
                            barderRadius: 0.5,
                            gridLines: {
                                display: false
                            },
                            title: {
                                display: false,
                                text: 'Time',
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'frequency'
                            },
                            ticks: {
                                // stepSize: 10,
                                fontFamily: "Orbitron",
                                maxRotation: 0,
                                minRotation: 0,
                                fontWeight: 800,
                                callback: function(val, index) {
                                    if(index == 0) {
                                        return this.getLabelForValue(val);
                                    } else if(this.chartLabels && val == this.chartLabels.length) {
                                        return this.getLabelForValue(val);
                                    }

                                    return index % 2 === 0 ? this.getLabelForValue(val) : '';
                                }
                            },
                        },
                        y: {
                            min: this.workoutStats.minHeartRate - 5,
                            max: this.workoutStats.maxHeartRate + 5,
                            title: {
                                display: false,
                                text: 'Heart Rate (bpm)',
                            },
                            //beginAtZero: true,
                        },
                    },
                },
            });
        },
        getLabelForValue(labelIndex) {
            if(this.chartLabels.length < labelIndex) {
                return this.chartLabels[labelIndex];
            }

            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
    canvas {
        width: 40rem !important;
        height: 15rem !important;
    }

    .chart-container {
        background-color: #1C1D1F;
        padding: 1rem;
        border-radius: 0.5rem;
    }

    .span-value {
        font-size: 0.9rem;
        font-weight: 700;
    }

    .label-name {
        font-size: 0.8rem;
        font-weight: 700;
    }

    .title {
        font-size: 1rem;
        font-weight: bold;
    }

    .status-container {
        display: flex;
        gap: 1rem;
        padding-left: 5%;
        padding-top: 0.5rem;
    }

    .status-label {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .status-label span {
        font-size: 0.8rem;
    }

    .color-box {
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 0.2rem;
    }

    .rest .color-box {
        // background-color: #8A74E6;
        background-color: #8A74E6;
    }

    .warm-up .color-box {
        // background-color: #00ffff;
        background-color: #74B8E6;        
    }

    .fat-burning .color-box {
        // background-color: #008000;
        background-color: #96F189;
    }

    .aerobic .color-box {
        // background-color: #ffff00;
        background-color: #FFE14B;
    }

    .anaerobic .color-box {
        // background-color: #ffa500;
        background-color: #E57E12;
    }

    .extreme .color-box {
        // background-color: #ff0000;
        background-color: #D20000;
    }
</style>